import { render, staticRenderFns } from "./bf-activate.vue?vue&type=template&id=e20890e4&scoped=true&lang=pug&"
import script from "./bf-activate.vue?vue&type=script&lang=js&"
export * from "./bf-activate.vue?vue&type=script&lang=js&"
import style0 from "./bf-activate.vue?vue&type=style&index=0&id=e20890e4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20890e4",
  null
  
)

export default component.exports